import React, { useState } from "react";
import { sendToPrinter } from "../utils/api";

// const PrintReceipt: React.FC<{ vendorId: string; orderId: string }> = ({ vendorId, orderId }) => {
const PrintReceipt: React.FC<{ orderId: number; }> = ({
    orderId,
}) => {


    const token = localStorage.getItem('token');

    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const vendorId = userData.vendor_id; // Get vendor ID from user data

    const [printEvent, setPrintEvent] = useState<string>("order_placed");
    const [printerLocation, setPrinterLocation] = useState<string>("kitchen");

    const [isModalVisible, setIsModalVisible] = useState(false);
    
    const handlePrint = async () => {
        try {
            const response = await sendToPrinter(vendorId, orderId, printEvent, printerLocation);
            // console.log(vendorId, orderId, printEvent, printerLocation, response);

            if (response.success) {
                alert("Receipt printed successfully!");
            } else {
                alert("Failed to print receipt.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while printing the receipt.");
        }
    };

    const closeIsModalVisible = () => {
        setIsModalVisible(false);
    };

    return (
        <div>
            <h3 className="font-semibold mb-4">Send Order #{orderId} to Printer</h3>

            {/* Dropdown for printEvent */}
            <label className="block mb-2">
                Print Event:
                <div className="block w-full border rounded p-2">
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="order_placed"
                            checked={printEvent === "order_placed"}
                            onChange={(e) => setPrintEvent(e.target.value)}
                            className="mr-2"
                        />
                        Order Placed
                    </label>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="order_completed"
                            checked={printEvent === "order_completed"}
                            onChange={(e) => setPrintEvent(e.target.value)}
                            className="mr-2"
                        />
                        Order Completed
                    </label>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="order_paid"
                            checked={printEvent === "order_paid"}
                            onChange={(e) => setPrintEvent(e.target.value)}
                            className="mr-2"
                        />
                        Order Paid
                    </label>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="order_refund"
                            checked={printEvent === "order_refund"}
                            onChange={(e) => setPrintEvent(e.target.value)}
                            className="mr-2"
                        />
                        Order Refund
                    </label>
                </div>
            </label>

            {/* Dropdown for printerLocation */}
            <label className="block mb-4">
                Printer Location:
                <div className="block w-full border rounded p-2">
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="kitchen"
                            checked={printerLocation === "kitchen"}
                            onChange={(e) => setPrinterLocation(e.target.value)}
                            className="mr-2"
                        />
                        Kitchen
                    </label>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="cashier"
                            checked={printerLocation === "cashier"}
                            onChange={(e) => setPrinterLocation(e.target.value)}
                            className="mr-2"
                        />
                        Cashier
                    </label>
                    <label className="block mb-2">
                        <input
                            type="radio"
                            value="bar"
                            checked={printerLocation === "bar"}
                            onChange={(e) => setPrinterLocation(e.target.value)}
                            className="mr-2"
                        />
                        Bar
                    </label>
                </div>
            </label>

            <button
                onClick={handlePrint}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
                Print Receipt
            </button>
        </div>
    );
};


export default PrintReceipt;
